import { Injectable, EventEmitter } from '@angular/core';
import { StartPaymentRequestModel } from '../../model/startPaymentRequestModel';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StartPaymentResponseModel } from '../../model/startPaymentResponseModel';
import { ContentPageModel } from '../../model/models';

@Injectable()
export class PaymentService {

  private notifyScsReturnToApplicationUrl : EventEmitter<String> = new EventEmitter<String>();


  constructor(private http: HttpClient) { }

  submitPaymentRequest(paymentRequest:StartPaymentRequestModel) {
    //POST /api/StartPayment
   return this.http.post<StartPaymentResponseModel>(environment.server_url + "/api/StartPayment", paymentRequest);

}

getPaymentReceipt(workflowId : number){

  //GET /api/Receipt
  const params = new HttpParams().set('workflowID', workflowId.toString());
  return this.http.get<ContentPageModel>(environment.server_url + "/api/Receipt", { params });

}

getNotifyScsReturnToApplicationUrl(){
  return this.notifyScsReturnToApplicationUrl;
}
}
 



// WEBPACK FOOTER //
// ./src/app/shared/payment/payment.service.ts